/**
 * 글 한 줄을 클립보드에 넣는다 — 링크 복사가 쓰는 한 자리.
 *
 * ⚠️ 보안 연결(https·localhost)이 아니면 브라우저가 클립보드 API 를 막는다 — 그때는 숨긴 입력칸을
 * 골라 복사하는 `document.execCommand('copy')` 로 넘어간다.
 * ⚠️ `execCommand` 는 입력칸이 **선택돼 있어야** 복사된다. 모달이 열려 있으면 포커스가 모달 밖으로
 * 나가지 못하므로 입력칸을 모달 «안»에 둔다 — 밖에 두면 「성공」을 돌려주고 아무것도 복사하지 않는다.
 *
 * @returns 복사됐나
 */
export async function copyText(value: string): Promise<boolean> {
  if (window.isSecureContext && navigator.clipboard) {
    try {
      await navigator.clipboard.writeText(value);
      return true;
    } catch {
      // 권한 거부 — 아래 방식으로 한 번 더
    }
  }

  const host = document.activeElement?.closest('[role="dialog"]') ?? document.querySelector('[role="dialog"]') ?? document.body;
  const area = document.createElement('textarea');
  area.value = value;
  area.style.position = 'fixed';
  area.style.top = '0';
  area.style.left = '0';
  area.style.width = '1px';
  area.style.height = '1px';
  area.style.opacity = '0';
  host.appendChild(area);
  area.focus({ preventScroll: true });
  area.select();
  area.setSelectionRange(0, value.length);
  try {
    return document.execCommand('copy');
  } catch {
    return false;
  } finally {
    area.remove();
  }
}
